module.exports = __webpack_public_path__ + "ph.f3f06f8e36ca36464922.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/ph.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/ph.svg
// module chunks = styles